export default function stripHtml(value) {
  let div = document.createElement('div')

  div.innerHTML = value

  let text = div.textContent || div.innerText || ''

  return text
}
